import TeamDetail from './detail';
import TeamsOverview from './overview';
import { SimulationProvider } from '../contexts/simulation';

// One provider for list and detail so a simulated pause survives moving
// between them; it is dropped when the user leaves the Teams section.
export default function TeamsWorkspace({ teamId }) {
    return (
        <SimulationProvider>
            {teamId != null ? <TeamDetail teamId={teamId} /> : <TeamsOverview />}
        </SimulationProvider>
    );
}
